import { styled } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'

export const Container = styled(Box)({
  display: 'flex',
  flexShrink: 0,
})
